import { researchAPI } from '@/providers/apis/research/research';
import { ResearchModel, TeamsModel } from '@/models/research/research';
import { unique } from '@/utils/utils';
/**
 * Store module for research page
 */
export default {
    namespaced: true,

    state: {
        researchProjects: [],
    },
    getters: {
        /**
         * categoryList holding category list
         */
        categoryList: (state: any) => {
            return unique(state.researchProjects, 'category');
        },
        /**
         * teamList hold the number of team list
         */
        teamList: (state: any) => {
            const result = [...new Set(state.researchProjects ? state.researchProjects.map(
                (item: ResearchModel) => item.teams && item.teams.map(
                (team: TeamsModel) => team.name)) : [])].flat(1);
            return [...new Set(result)];
        },
    },
    mutations: {
        /**
         * Handle the state params
         * @param state
         * @param projects
         */
        fetchResearchProjects(state: any, projects: ResearchModel[]) {
            state.researchProjects = projects;
        },
    },

    actions: {
        /**
         * call the fetch research project list
         * @param context
         */
        fetchResearchProjects(context: any) {
            researchAPI.fetchProjects().then((projects) => {
                context.commit('fetchResearchProjects', projects);
            });
        },
    },
};
